import * as $ from 'jquery';
import 'jquery-colorbox';

const lightbox = () => {
	let $elem = $('.resources, .product__image');
	if ($elem.length == 0) {
		return;
	}
	for (let i = 0, l = $elem.length; i < l; i++) {
		let $element = ($elem[i].nodeName == 'A') ? $($elem[i]) : $($elem[i]).find('.item__image a:not([href*=".pdf"])');
		$element.colorbox({
			transition: 'elastic',
			opacity: .60,
			initialWidth: '200',
			initialHeight: '200',
			maxWidth: '100%',
			maxHeight: '100%',
			fixed: true,
			close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" height="44" fill="#000"><path d="M13.458 15.336l1.485-1.485 15.344 15.344-1.485 1.485z"> </path><path d="M12.961 29.2l15.344-15.343 1.485 1.485-15.344 15.344z"> </path></svg><span>Close</span>',
			rel: 'items' + i,
			html: function () {
				if (this.getAttribute('href').indexOf('youtube.com') !== -1) {
					return '<iframe width="860" height="645" src="' + this.getAttribute('href') + '" frameborder="0" allowfullscreen></iframe>';
				} else {
					return false;
				}
			},
			current: "{current} of {total}",
			previous: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20" height="20"><path fill="none" stroke="#000" stroke-width="2" d="M11 14.5L4.9 7.9 11 1.3"> </path></svg><span>Previous</span>',
			next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20" height="20"><path fill="none" stroke="#000" stroke-width="2" d="M5 1.2l6.1 6.6L5 14.4"> </path></svg><span>Next</span>',
			title: function(){
				// TODO: FIX THIS, it's failing
				console.log(this);
				console.log(this.getAttribute('title'));
				console.log(this.querySelector('img'));
				return this.getAttribute('title') || this.querySelector('img').getAttribute('alt');
			},
			onOpen: () => {
				document.querySelector('html').classList.add('lockScroll');
			},
			onClosed: () => {
				document.querySelector('html').classList.remove('lockScroll');
			}
		});
	}
};

export default lightbox;